export interface StudioCaptureForm {
  id: string;
  name: string;
  shareToken: string;
  desktopHeight: number;
  mobileHeight: number;
}

export interface StudioCaptureFormsResponse {
  linked: boolean;
  studioAppOrigin?: string;
  forms: StudioCaptureForm[];
}

export function isShareToken(value: string): boolean {
  return /^[a-f0-9]{32}$/i.test(value);
}
